import { themed } from '@indeed/ifl-css';
import { TagListExpandedState } from './TagList';
export const TagListOuterContainer = themed('div', {
    styleProps: ['expandedState', 'maxHeight'],
    shouldForwardProp: (prop) => prop !== 'expandedState' && prop !== 'maxHeight'
})(({ expandedState, maxHeight }) => [
    {
        overflow: 'hidden',
        padding: 2
    },
    expandedState === TagListExpandedState.EXPANDED || typeof maxHeight === 'undefined'
        ? {}
        : {
            maxHeight: `${Math.ceil(maxHeight)}px`
        }
]);
export const TagListContainer = themed('ul')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    position: 'relative',
    gap: 2,
    margin: 0,
    padding: 0
}));
//# sourceMappingURL=Containers.js.map